import { render, staticRenderFns } from "./vCkeditor.vue?vue&type=template&id=6d41a451&scoped=true"
import script from "./vCkeditor.vue?vue&type=script&lang=js"
export * from "./vCkeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41a451",
  null
  
)

export default component.exports